// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { URL } from "../../service/Service";

const formatCurrency = (value) => {
  const numberValue = Number(value || 0);
  return `${numberValue.toFixed(2).replace(".", ",")}€`;
};

const getApiMessage = async (response) => {
  try {
    const data = await response.json();
    return data?.message || data?.error || "";
  } catch {
    try {
      return await response.text();
    } catch {
      return "";
    }
  }
};

const WithdrawalFormAdmin = () => {
  const { id } = useParams();

  const [balanceData, setBalanceData] = useState({ balance: 0 });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(true);

  const jwtToken = sessionStorage.getItem("jwt");

  const fetchBalanceData = useCallback(async () => {
    if (!id || !jwtToken) return;

    try {
      setLoadingBalance(true);

      const response = await fetch(`${URL}/api/partners/${id}/balance`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch balance data");
      }

      const data = await response.json();
      setBalanceData(data || { balance: 0 });
    } catch (error) {
      console.error("Error fetching balance data:", error);
      setErrorMessage("Não foi possível carregar o saldo atual.");
    } finally {
      setLoadingBalance(false);
    }
  }, [id, jwtToken]);

  useEffect(() => {
    fetchBalanceData();
  }, [fetchBalanceData]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (loadingSubmit) return;

    const amountToWithdraw = Number(balanceData?.balance || 0);

    if (!jwtToken) {
      setErrorMessage("Sessão expirada. Faça login novamente.");
      return;
    }

    if (!id) {
      setErrorMessage("Não foi possível identificar o parceiro.");
      return;
    }

    if (amountToWithdraw < 50) {
      setErrorMessage("O valor mínimo para levantamento é 50,00€.");
      return;
    }

    try {
      setLoadingSubmit(true);
      setSuccessMessage("");
      setErrorMessage("");

      const response = await fetch(`${URL}/api/partners/${id}/withdrawals`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({ recordAmount: amountToWithdraw }),
      });

      const message = await getApiMessage(response);

      if (!response.ok) {
        throw new Error(
            message || "Não foi possível enviar o pedido de levantamento."
        );
      }

      setSuccessMessage(
          message ||
          "Pedido de levantamento efetuado com sucesso. O financeiro foi notificado por email."
      );

      window.setTimeout(() => {
        window.location.reload();
      }, 1800);
    } catch (error) {
      console.error("Erro ao pedir levantamento:", error);
      setErrorMessage(
          error?.message ||
          "Não foi possível pedir o levantamento. Confirme se o email está funcional."
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  const balance = Number(balanceData?.balance || 0);
  const canRequestWithdrawal = balance >= 50 && !loadingSubmit && !loadingBalance;

  return (
      <div className="w-[420px] max-w-[calc(100vw-48px)] p-2">
        <h1 className="mb-2 text-lg font-black text-gray-950">
          Pedido de levantamento
        </h1>
        <p className="mb-5 text-sm text-gray-500">
          Será criado um pedido de levantamento para este parceiro e enviado um email ao financeiro.
        </p>

        {successMessage && (
            <div className="mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-semibold text-emerald-700">
              {successMessage}
            </div>
        )}

        {errorMessage && (
            <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
              {errorMessage}
            </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-5 rounded-2xl border border-gray-200 bg-gray-50 p-4">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-gray-500">
              Saldo disponível
            </p>
            <p className="mt-2 text-3xl font-black text-green-cl">
              {loadingBalance ? "A carregar..." : formatCurrency(balance)}
            </p>
            <p className="mt-2 text-xs text-gray-500">
              Apenas levantamentos a partir de 50,00€ serão aceites.
            </p>
          </div>

          <button
              type="submit"
              name="requestWithdrawalAdminButton"
              disabled={!canRequestWithdrawal}
              title={
                balance < 50
                    ? "É necessário um saldo mínimo de 50,00€."
                    : "Enviar pedido de levantamento"
              }
              className={`w-full rounded-xl px-4 py-3 text-sm font-bold text-white shadow-sm transition ${
                  canRequestWithdrawal
                      ? "bg-green-cl hover:bg-green-900"
                      : "cursor-not-allowed bg-gray-400"
              }`}
          >
            {loadingSubmit ? "A enviar pedido..." : "Confirmar levantamento"}
          </button>
        </form>
      </div>
  );
};

export default WithdrawalFormAdmin;
